export const DEFAULT_FILTERS = {
  query: '',
  query_type: 1,
  providers: [],
  status: null,
  categories: [],
  date_from: null,
  date_to: null,
  range: 'today',
}

export const DEFAULT_COUNTS = {
  count_orders: 0,
  charge: 0,
  cost: 0,
  profit: 0,
  refunded: 0,
}
